module.exports = __webpack_public_path__ + "static/media/logo_citizen_app.f3cf47eb.png";